export default __webpack_public_path__ + "static/media/DrumKit.4ff89d24.PNG";